import e from "../managers/braze-instance.js";
export function getUser() {
  if (e.X()) return e.pr();
}
